import styled from 'styled-components';

export const Container = styled.div({
  display: 'flex',
  rowGap: '30rem',
  columnGap: '16rem',
  flexWrap: 'wrap',
});
